import { Navigate } from 'react-router-dom';
import type { ReactNode } from 'react';
import type { ModuleKey } from '@erp/data-access/interfaces';
import { useEnabledModules } from '@/hooks/use-modules';

// Route-level companion to the sidebar's module gating: a logged-in user
// who isn't allowed the module gets bounced to the dashboard instead of
// rendering the module's pages. Sidebar visibility + this guard share the
// same `useEnabledModules()` source so they can never disagree.
//
// While the gate is still loading we render `null` rather than a splash:
// the parent ProtectedRoute already shows a brand splash during auth/
// tenant resolution, and the modules query is fast enough (typically <
// 100ms after auth resolves) that a second flash would be more
// distracting than helpful.
export function ModuleGuard({
  module,
  children,
}: {
  module: ModuleKey;
  children: ReactNode;
}) {
  const { enabled, isLoading } = useEnabledModules();
  if (isLoading) return null;
  if (!enabled.has(module)) return <Navigate to="/" replace />;
  return <>{children}</>;
}
